import React, { Component } from 'react';
import "./resumeStyles.css";

export default class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="resume">

        <div className="row education">

          <div className="three columns header-col">
            <h1><span>Education</span></h1>
          </div>

          <div className="nine columns main-col">
            {
              resumeData.education && resumeData.education.map((item) => {
                return (
                  <div className="row item">
                    <div className="twelve columns">
                      <h3>{item.UniversityName}</h3>
                      <p className="info">
                        {item.specialization}
                        <span>&bull;</span> <em className="date">{item.MonthOfPassing} {item.YearOfPassing}</em></p>
                      <p>
                        {item.Achievements}
                      </p>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Work</span></h1>
          </div>

          <div className="nine columns main-col">
            {
              resumeData.work && resumeData.work.map((item) => {
                return (
                  <div className="row item">
                    <div className="twelve columns">
                      <h3>{item.CompanyName}</h3>
                      <p className="info">
                        {item.specialization}
                        <span>&bull;</span> <em className="date">{item.MonthOfLeaving} {item.YearOfLeaving}</em></p>
                      <p style={{color:"rgb(120,120,120)"}}>
                        {item.Achievements}
                      </p>
                    </div>

                  </div>

                )
              })
            }
          </div>
        </div>


        <div className="row skill">

          <div className="three columns header-col">
            <h1><span>Technical Skills</span></h1>
          </div>

          <div className="nine columns main-col">
            <h4>{"Front-End"}</h4>
            <div >
              <ul className="skills">
                {resumeData.skills.frontEnd.map(item => (
                  <div style={{ background: 'linear-gradient(to right, #191654,#43C6AC)', alignContent: "center" }} className="front-end-item" key={item}>
                    {item}
                  </div>
                ))}
              </ul>

            </div>
            <h4>{"Back-End"}</h4>
            <div >
              <ul className="skills">
                {resumeData.skills.backEnd.map(item => (
                  <div style={{ background: 'linear-gradient(to right, #833AB4,#ec6ead  )', alignContent: "center" }} className="front-end-item" key={item}>
                    {item}
                  </div>
                ))}
              </ul>

            </div>
            <h4>{"Databases"}</h4>
            <div >
              <ul className="skills">
                {resumeData.skills.database.map(item => (
                  <div style={{ background: 'linear-gradient(to right,  #FF5F6D,#FF5F6D,#fcb045)', alignContent: "center" }} className="front-end-item" key={item}>
                    {item}
                  </div>
                ))}
              </ul>
              <h4>{"Payment Gateways"}</h4>
              <div >
                <ul className="skills">
                  {resumeData.skills.payment.map(item => (
                    <div style={{ background: 'linear-gradient(to right,  #185a9d,#43cea2)', alignContent: "center" }} className="front-end-item" key={item}>
                      {item}
                    </div>
                  ))}
                </ul>
              </div>
              <h4>{"Others"}</h4>
              <div >
                <ul className="skills">
                  {resumeData.skills.others.map(item => (
                    <div style={{ background: 'linear-gradient(to right,  #00223e,#ffa17f)', alignContent: "center" }} className="front-end-item" key={item}>
                      {item}
                    </div>
                  ))}
                </ul>
              </div>
            </div>

          </div>

        </div>

      </section>
    );
  }
}